<template>
<div class="col-xxl-5 col-xl-4 col-sm-6 box-col-40">
    <div class="card recent-order">
        <div class="card-header pb-0">
            <h3>Recent Orders</h3>
        </div>
        <div class="card-body pb-0">
            <div class="medium-chart">
                <div class="recent-chart" id="recent-chart">
                    <apexchart type="area" height="360" :options="recent.options" :series="recent.series"></apexchart>
                </div>
            </div>
          
          
        </div>
    </div>
</div>
</template>

<script>
import charts from '../../../data/charts'
export default {
    name: 'recentPage',
    data() {
        return {
            recent: charts.recent
       
        }
    }
    }
</script>
